import { Head, Link, router, usePage } from "@inertiajs/react"
import { FormattedMessage, useIntl } from "react-intl"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"

export default function ConfirmationPending() {
  const intl = useIntl()
  const { email } = usePage<{ email: string }>().props
  const title = intl.formatMessage({ id: "auth.confirmation_pending.title" })
  const description = intl.formatMessage({ id: "auth.confirmation_pending.description" })

  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <AuthShell>
        <h2 className="text-2xl">{title}</h2>
        <p className="mt-2">
          <FormattedMessage
            id="auth.confirmation_pending.message"
            values={{ email, strong: (chunks) => <strong>{chunks}</strong> }}
          />
        </p>
        <div className="mt-6">
          <Button variant="secondary" onClick={() => router.post("/confirmations")}>
            {intl.formatMessage({ id: "auth.confirmation_pending.resend" })}
          </Button>
        </div>
        <p className="mt-6">
          <Link href="/login">{intl.formatMessage({ id: "auth.back_to_login" })}</Link>
        </p>
      </AuthShell>
    </>
  )
}
